import { queryKeyPrefix } from 'src/features/tanStackQuery/queryKeyPrefix'

export const queryKeys = {
  usersAll: [...queryKeyPrefix.common, 'users'],
  users: (limit?: number) =>
    [...queryKeyPrefix.common, 'users', { limit }] as const,
}
